const storage = {};
let forage = {};

function objectWithoutProperties(obj, keys) {
    let target = {};
    for (const i in obj) {
        if (keys.indexOf(i) >= 0) {
            continue;
        }
        if (!Object.prototype.hasOwnProperty.call(obj, i)) {
            continue;
        }
        target[i] = obj[i];
    }
    return target;
}

function execPromiseCallback(promise, callback) {
    if (callback) {
        promise.then(result => {
            callback(null, result);
        });
    }
}

export function get(cb) {
    cb(storage);
}

export function set(cb, prefs) {
    Object.assign(storage, prefs);
    cb();
}

export function remove(cb, key) {
    delete storage[key];
    cb();
}

export function getItem(key, callback) {
    const promise = new Promise(resolve => {
        if (typeof forage[key] !== 'undefined') {
            resolve(forage[key]);
        } else {
            resolve(null);
        }
    });
    execPromiseCallback(promise, callback);
    return promise;
}

export function setItem(key, value, callback) {
    forage[key] = value;
    const promise = new Promise(resolve => {
        resolve(value);
    });
    execPromiseCallback(promise, callback);
    return promise;
}

export function removeItem(key, callback) {
    forage = objectWithoutProperties(forage, [key]);
    const promise = new Promise(resolve => {
        resolve();
    });
    execPromiseCallback(promise, callback);
    return promise;
}
